import { graphql } from 'react-apollo'
import { SHARE_LINK } from '../../graphql/mutations'

export default graphql(SHARE_LINK, { name: 'shareDirectLinks' })
